import { createContext, ReactNode, useState } from 'react';

interface DeepSearchLayoutContextType {
  sidebarCollapsed: boolean;
  setSidebarCollapsed: (v: boolean) => void;
}

export const DeepSearchLayoutContext =
  createContext<DeepSearchLayoutContextType>({
    sidebarCollapsed: false,
    setSidebarCollapsed: () => {},
  });

export const DeepSearchLayoutProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <DeepSearchLayoutContext.Provider
      value={{ sidebarCollapsed, setSidebarCollapsed }}
    >
      {children}
    </DeepSearchLayoutContext.Provider>
  );
};
